import React, { useState, useContext, useEffect } from "react";
import styles from "../Transfer/TransferModal.module.css";
import { getUsersByStore } from '../../../hooks/User';
import { transferExpiredProductsToAnotherUser } from '../../../hooks/ExpiredProduct';
import { StoresContext } from '../../../context/StoresContext';
import { ExpiredProductContext } from '../../../context/ExpiredProductContext';
import { UserContext } from '../../../context/UserContext';

const Modal = ({ closeModal }) => {
    const { selectedStore } = useContext(StoresContext);
    const { expiredproductIds, setIsTransferred } = useContext( ExpiredProductContext );
    const { userIds } = useContext(UserContext);
    const [users, setUsers] = useState([]); 
    const [fromUser, setFromUser] = useState([]);
    const [toUserId, setToUserId] = useState(null);

  useEffect(() => { 
    filterUserByStoreId()
  },[])

  const filterUserByStoreId = async () => {
    if (!selectedStore?.id) return;
    try {
      const response = await getUsersByStore(selectedStore.id);
      const users = response?.data?.users || [];
      const appUsers = users.filter(user => user.role === "APP_USER");
      if (userIds?.length > 0) {
        const userFromSelection = appUsers.find(user => 
          userIds.includes(user.id)
        );
        
        if (userFromSelection) {
          setFromUser(userFromSelection);
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setFromUser(null);
    }
  };

  useEffect(() => { 
    fetchUsersByStoreId()
  },[fromUser])

  const fetchUsersByStoreId = async () => {
        if(selectedStore != null && selectedStore.id != null) {
          try {
            const response = await getUsersByStore(selectedStore.id);
            if (response?.data?.users) {
                const filteredUsers = response.data.users.filter(user => user.role === "APP_USER" && user.id !== fromUser.id);
                setUsers( filteredUsers );
            } else {
                console.error("Failed to fetch users or no users found.");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
        }
    };

    const onTransfer = async () => {
      const transferData = {
        fromUserId : fromUser.id,
        toUserId : toUserId, 
        expiredProductIds: expiredproductIds, 
    };
        try {
          const response = await transferExpiredProductsToAnotherUser( transferData );
          if(response) {
            setIsTransferred(true)
            closeModal();
          }else {
              // TODO()
          }
        }catch (error) {
            console.error("Error transfer products to another user:", error);
        }
    }

    const renderUserNameForm = () => {
      return (
          <form className={styles.formContainer}>
              <p>Transferir produtos do colaborador:</p>
              <div className={styles.checkboxContainer}>
                <div className={styles.checkboxWrapper}>
                    <input
                      type="radio"
                      name="from-user-selection"
                      checked={fromUser.id}
                      className={styles.checkbox}
                    />
                    <span>{fromUser.name}</span>
                </div>
                  <p>Para colaborador:</p>
                  {users.map(({ id, name }) => (
                      <div key={`to-${id}`} className={styles.checkboxWrapper}>
                          <input
                              type="radio"
                              name="to-user-selection"
                              checked={toUserId === id}
                              onChange={() => setToUserId(id)}
                              className={styles.checkbox}
                          />
                          <span>{name}</span>
                      </div>
                  ))}
              </div>
          </form>
      );
  };
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <p  className={styles.filtersTitle}>Transferência de Produtos</p>
          { selectedStore.id != null && renderUserNameForm() }
        </div>
        <div className={styles.buttonContent}>
          <button onClick={ onTransfer } className={styles.buttonConfirm}>Transferir Produtos</button>
          <button onClick={ closeModal } className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
